import reducer from "./reducer";
import middleware from "./middleware";
import {registerMiddleware, registerReducer} from "../../store";

registerMiddleware("currentConnector", middleware);

registerReducer("currentConnector", reducer);

export {default as MonitorCurrentConnector} from "./components/MonitorCurrentConnector"